import { PageActionType } from './page-action-type';
import { castArray } from 'lodash';

export interface CreatePageErrorAction {
  pageKey: string;
  errors: Error[];
  type: PageActionType.CreatePageError;
}

export const createPageError = (
  pageKey: string,
  errors: Error | readonly Error[],
): CreatePageErrorAction => ({
  errors: castArray(errors),
  pageKey,
  type: PageActionType.CreatePageError,
});
